function formatTwoDigitNumber(key: number) {
  if (key < 10) {
    return `0${String(key)}`;
  }

  return String(key);
}

export { formatTwoDigitNumber };
